var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"TrustSection"}},[_c('b-container',[_c('b-row',[_c('b-col',[_c('h3',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.acf.acf.titleTrusted)}}),_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.acf.acf.descriptionTrusted)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }